import React from "react"

const CopyrightFooter = props => {
  return <p>© {new Date().getFullYear()} IOLIS Solutions</p>
}

export default CopyrightFooter
